import Vue from 'vue';

import '@cnamts/vue-dot/dist/vue-dot.css';
import VueDot from '@cnamts/vue-dot';

import '@/theme/theme.scss';

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

Vue.use(VueDot);

